/* eslint-disable react/prop-types */
import { RadioGroup } from '@mui/material';
import { Radio } from './Inputs';
import classes from './RadioPart.module.css';

const RADIOLIST = [
  {
    value: '1',
    label: 'Default On',
    recommended: 'Recommended',
    desc: 'Return Option will be On by default. Buyers can choose to opt-out.',
  },
  {
    value: '2',
    label: 'Default Off',
    desc: 'Return Option will be Off by default. Buyers can choose to opt-in.',
  },
];

export default function RadioPart({
  radioValue, radioOnChange, radioList = RADIOLIST,
}) {
  return (
    <div className={classes.setting_edit}>
      <RadioGroup>
        {radioList.map(({
          value, label, recommended, desc,
        }) => (
          <div className={classes.radio_item} key={value}>
            <div className={classes.radio}>
              <Radio
                checkedcolor="#645AFF"
                onChange={radioOnChange}
                value={value}
                style={{
                  padding: '0PX',
                  marginRight: '8PX',
                }}
                checked={value === radioValue}
              />
              {label}
              {recommended
                && <div className={classes.recommended}>{recommended}</div>}
            </div>
            <div className={classes.radio_desc}>{desc}</div>
          </div>

        ))}
      </RadioGroup>
    </div>
  );
}
